var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.704,
    height: 13.677,
    viewBox: "0 0 8.704 13.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M21.352,26.677A4.357,4.357,0,0,1,17,22.325V15.8a2.8,2.8,0,1,1,5.6,0v6.217a.933.933,0,0,1-1.865,0V15.8a.933.933,0,1,0-1.865,0v6.528a2.487,2.487,0,0,0,4.973,0V13.933a.933.933,0,1,1,1.865,0v8.393A4.357,4.357,0,0,1,21.352,26.677Z",
    transform: "translate(-17 -13)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.a142e0c99e7d81d3210c563576c3299b.svg";
export { ForwardRef as ReactComponent };